import './Banner.scss'

import { Link } from 'react-router-dom'

interface Props {
  height?: number
  image: string
  link?: string
  kategoriId?: number
  value?: number
}

const Banner: React.FC<Props> = ({ height, image, link, kategoriId, value }) => {
  const style = { height: height ? height : 'auto' }
  const img = <img src={image} alt="banner" style={{ objectPosition: 'left' }} />

  const isExternal = link && link !== '#' && (link.startsWith('http://') || link.startsWith('https://'))
  const isInternal = link && link !== '#' && !isExternal

  if (isExternal) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" style={style} className="banner">
        {img}
      </a>
    )
  }

  if (isInternal) {
    return (
      <Link to={link!} style={style} className="banner">
        {img}
      </Link>
    )
  }

  // value===1 olan eski alan1 davranışını koru
  if (value === 1 && kategoriId) {
    return (
      <Link to={`crossproduct/${kategoriId}`} style={style} className="banner">
        {img}
      </Link>
    )
  }

  return (
    <div className="banner" style={style}>
      {img}
    </div>
  )
}

export default Banner
